import { CommonModule } from "@angular/common";
import { CalendarComponent } from "./shared/components/calendar/c.component";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { DateTimePipe } from "./shared/pipes/Converter.pipe";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpLoaderFactory } from "app/app.module";
import { HttpClient } from "@angular/common/http";
import { SliderModule } from 'primeng/slider';
import { CheckboxModule } from 'primeng/checkbox';

@NgModule({
    declarations: [
        CalendarComponent,
        DateTimePipe
    ],
    imports: [CommonModule,
        FormsModule,
        SliderModule,
        TranslateModule,
        CheckboxModule
    ],
    exports: [
        CalendarComponent,
        DateTimePipe,
        TranslateModule,
        SliderModule,
        CheckboxModule
    ]
})
export class SharedModule { }